import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Box from "@material-ui/core/Box"
import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import { EmbedInstagram, EmbedFacebook } from "../bits/EmbedSocialMedia"
const useStyles = makeStyles(theme => ({
  Section: {
    background: "transparent",
    textAlign: "center",
    padding: theme.spacing(16, 1),
  },
  Grid: {
    background: "inherit",
    justifyContent: "center",
    margin: "auto",
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: 1200,
    },
  },
  GridItem: {
    height: "auto",
  },
  Paper: {
    padding: 0,
    boxShadow: "-2px 0px 16px #ccc, 2px 10px 28px #ccc",
    margin: "auto",
    maxWidth: theme.spacing(48.5),
    height: "auto",

    "& p:first-of-type": {
      background: "purple",
      color: theme.palette.text.secondary,
      padding: theme.spacing(2, 1),
    },
  },
  hint: {
    margin: "auto",
    padding: theme.spacing(2, 1),
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: 1200,
    },
  },
  frame: {
    width: "100%",
    height: "100%",
  },
}))
const Socials = () => {
  const classes = useStyles()
  return (
    <Box component="section" className={classes.Section} id="socials">
      <Grid container spacing={2} className={classes.Grid}>
        <Grid item xs={12} sm={5} className={classes.GridItem}>
          <Paper className={classes.Paper}>
            <Typography>VIEW OUR INSTAGRAM PICS</Typography>
            <Box className={classes.frame}>
              <EmbedInstagram />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={5} className={classes.GridItem}>
          <Paper className={classes.Paper}>
            <Typography>LIKE US ON FACEBOOK</Typography>
            <Box className={classes.frame}>
              <EmbedFacebook />
            </Box>
          </Paper>
        </Grid>
      </Grid>
      <Typography className={classes.hint}>
        See what we're up to, follow us on social media
      </Typography>
    </Box>
  )
}

export default Socials
